export default {
    MENU: {
        HOME: 'Home',
        DOCUMENT: 'Documentation',
        PROFILE: 'Personal information',
        ADVANTAGE_PRODUCTS: 'Products with tax advantage',
        OTHER_PRODUCTS: 'Other products',
        LEGAL: 'Legal warning',
        PRIVACY: 'Privacy policies',
        COOKIE_MESSAGE: 'This website uses cookies to improve the experience',
        COMPENSATION: 'My Compensation',
        FLEXIBLE: 'Tax advantage products',
        DOCUMENTATION: 'Documentation',
        PERSONAL: 'Personal information',
        MY_COMPENATION: 'My compensation',
        EXPENSE_MANAGEMENT: 'Expense management',
        CORPORATE_SOCIAL_RESPONSIBILITY: 'Corporate social responsability',
        HELLO: 'Hello',
        WELCOME_MESSAGE: 'Welcome to your flexible remuneration plan. In the “Documentation” section you will find all the necessary information. Remember that you must first complete the “Personal information” section.',
        TERMS_AND_CONDITIONS: 'Terms and conditions'
    },
    HEADER: {
        SAVED: 'Saved',
        PENDING_SAVING: 'Possible savings',
        LIMIT: 'Expense limit',
        REACHED: 'Reached',
        LANGUAGE: 'Language',
        CHECKOUT: 'Checkout',
        LOGOUT: 'Log Out',
        HELP: 'Help',
        CONTACT: 'Contact us',
    },
    HOME: {
        MISSING_PROFILE_INFO: 'Incomplete user information: Please check that you have filled in the email / phone in your profile',
        CURRENT_SITUATION: 'Current Situation',
        NEWS: 'News',
        PRODUCTS_WITH_TAX: 'Products With Tax Advantage',
        ALERTS: 'Alerts',
        CONTRACTED_PRODUCTS: 'Contracted products',
        PENDING_SIGNATURE: 'Pending signature',
        PENDING_PRODUCTS: 'Pending products',
        SAVING: 'Saving',
        PENDING_SAVING: 'Pending saving',
        NON_SIMULATED_PRODUCT: 'Non-simulated product',
        PENDING_SIMULATIONS: 'Pending Simulations',
        NO_ACTIVE_ALERTS: 'No Active Alerts',
        PRODUCT: 'Product',
        Status: 'Status',
        END_DATE: 'End date',
        Expiring: 'Expiring',
        Go: 'Go',
        MISSING_DOCUMENT: 'Missing document',
        ATTACH_INVOICE: 'Attach invoice month',
        PENDING_CART: 'Pending cart',
        PENDING_REVIEW: 'Pending review',
        CONTRACTED: 'Contracted',
        CANCELLED: 'Cancelled',
    },
    LIFE_AXA: {
        FALLCC: 'Death from any cause',
        FALLA: 'Death due to accident',
        FALLAC: 'Death due to traffic accident',
        IPAA: 'Absolute Permanent Disability due to accident',
        IPAAC: 'Absolute Permanent Disability due to traffic accident',
        IPACC: 'Absolute Permanent Disability from any cause',
        GINV: 'Great Disability',
        MANDATORY: 'Mandatory',
        MANDATORY_2: 'mandatory to hire',
        AGE_LIMIT: 'Not available for your age',
        CANNOT_EXCEED: 'cannot exceed',
        CANNOT_LESS_FALLA: 'It cannot be less than 35.000 €'
    },
    COMPENSATION: {
        Benefits: 'Social Benefits',
        TotalCompensation: 'Total Compensation',
        TotalSecurityCost: 'Social Security Cost'
    },
    DOCUMENT: {
        Documents: 'Documents',
        DETAIL_ACTION: 'Detail action',
        DETAIL: 'Detail',
        ID: 'Id',
        YEAR: 'Year',
        NAME: 'Name',
        CREATED_BY: 'Created by',
        CREATED_AT: 'Created at',
        LAST_MODIFICATION: 'Last modification',
        Admin: 'Admin',
        no_documents: 'No documents uploaded',
        no_products: 'No products contracted',
    },
    product_names: {
        'health-insurance': 'Health Insurance',
        transport: 'Transport',
        food: 'Food',
        kindergarten: 'Kindergarden',
        formation: 'Training',
        renting: 'Renting',
        'life-insurance': 'Life Insurance',
        'life-insurance-axa': 'Life Insurance',
        'saving-plan': 'Saving Plan',
        gym: 'Gym',
        lottery: 'Lottery',
        informative: 'Informative',
    },
    profile: {
        user_tab: 'User information',
        employee_tab: 'Employee legal data',
        family_tab: 'Family information',
        office: 'Office',
        incorrect_password: 'The password does not meets the minimum requirements: It must have a minimum of 8 characters, contain numbers and letters, at least one upper/lower case character, and no spaces',
        incorrect_repeat_password: 'Password does not match',
        password_deprecated: 'Password is too old. Please reset password',
        collective: 'Collective',
        legal_entity: 'Legal entity',
        email: 'Email',
        password: 'Password',
        repeat_password: 'Repeat password',
        id: 'Identifier<small>(DNI,NIE,Passports)</small>',
        phone: 'Phone number',
        bank: 'Bank number<small>(BAN)</small>',
        nationality: 'Nationality',
        birthday: 'Birthday',
        Gender: 'Gender',
        Male: 'Male',
        Female: 'Female',
        disability: 'disability',
        No: 'No',
        Yes: 'Yes',
        marital_status: 'Marital Status',
        Single: 'Single',
        Married: 'Married',
        Divorced: 'Divorced',
        Widowed: 'Widowed',
        Address1: 'Address1',
        Address2: 'Address2',
        City: 'City',
        Country: 'Country',
        Province: 'Province',
        postal_code: 'Postal code',
        fixed_salary: 'Fixed Salary',
        flexible_bag: 'Flexible Bag',
        top_bag: 'Top Bag',
        variable_salary: 'Variable Salary',
        number_payments: 'Number of payments',
        social_security: 'Social Security Number',
        employee_number: 'Employee number',
        cost_center: 'Cost center',
        renting: 'Renting',
        private_use: 'Renting Private Use',
        relationship: 'Relationship',
        spouse: 'Spouse',
        child: 'Child',
        domestic_partner: 'Domestic Partner',
        name: 'Name',
        surname: 'Surname',
        first_name: 'First name',
        last_name: 'Last name',
        last_name_2: 'Second Last name',
        address: 'Address',
        subPolicy: 'Subpolicy',
        policy: 'Policy',
        contribution: 'Contribution',
        publicResponsibility: 'Public Responsibility',
        typeOfStreet: 'Type of street',
        houseNumber: 'Number',
        mobilePhonePrefix: 'Mobile phone prefix',
        birthCountry: 'Country of birth',
        residenceCountry: 'Country of residence',
        investmentBasket: 'Basket',
        investmentProfile: 'Investment profile',
        contributionDate: 'Contribution upload date',
        companyCIF: 'CIF Company',
        population: 'Population',
        residence: 'Residence',
        complement: 'Complement',
    },
    buttons: {
        accept: 'ACCEPT',
        accept_lower: 'Accept',
        consent_lower: 'Understood',
        close: 'CLOSE',
        add_cart: 'ADD TO CART',
        update_cart: 'UPDATE CART',
        remove_cart: 'REMOVE FROM CART',
        update_contract: 'UPDATE CONTRACT',
        reset: 'RESET',
        see_details: 'See details',
        sign: 'SIGN',
        back: 'BACK',
        update: 'UPDATE',
        cancel: 'CANCEL',
        download: 'DOWNLOAD',
        click_here: 'CLICK HERE',
        back_simulation: 'BACK TO SIMULATION',
        next_step: 'NEXT STEP',
        add_child: 'ADD CHILD',
        add_family: 'ADD FAMILY',
        select: 'SELECT',
        delete: 'DELETE',
        add_member: 'ADD MEMBER',
        reset_password: 'Reset password',
        forgot_password: 'Have you forgot the password?',
        back_to_login: 'Back to login',
        change_language: 'change',
    },
    calculator: {
        header: 'TAX SAVINGS SIMULATOR',
        increase_dis_income: 'Increase in disposable income',
        equi_salary_increase: 'Equivalent salary increase',
        not_available: 'calculator not available: cause: salary info incomplete',
        edit_profile: 'edit salary info in the users profile',
        fixed_salary: 'Fixed Salary',
        variable_salary: 'Variable Salary',
        flexible_products: 'Flexible products',
        without_remuneration: 'Without flexible payment plan',
        with_remuneration: 'With flexible payment plan',
        non_flexible_products: 'Non Flexible products',
        total_gross_salary: 'Total Gross Salary',
        social_security: 'Social security',
        pit: 'PIT',
        withholding_account: 'Withholding on account',
        net_salary: 'Net Salary',
        net_available_salary: 'Net Available Salary',
        employee_bag: 'Employee Bag',
        employee_top_bag: 'Top Bag',
        employee_user_bag: 'User Bag',
        company_bag: 'Company Bag',
        contribution_company: 'Contribution company',
        available: 'Available',
        spent: 'Spent',
    },
    products: {
        health_insurance: 'Healh Insurance',
        saving_insurance: 'Savings Insurance',
        unit_linked_4_portfolio: 'Unit Linked Saving Insurance 4 Portfolios',
        unit_linked_lifecycle: 'Unit Linked Saving Insurance Lifecycle',
        month_text: 'Enter the amount available each month',
        min_amount_text: 'Min monthly amount to contract this contract',
        max_amount_text: 'Maximum available monthly amount to contract this contract',
        max_available: 'Maximum available monthly',
        transport_max_text: 'The amount limit is € 1500 per year',
        start_date: 'Start date',
        privative_use: 'Privative use',
        year: 'year',
        years: 'Years',
        vehicle_value: 'Vehicule value',
        with_no_tax: 'Quota without TAX',
        with_tax: 'Quota with TAX',
        number_tickets: 'Number of tickets',
        price_tickets: 'Price per ticket',
        death_capital: 'Death capital',
        capital_disability: 'Capital Disability (optional)',
        yearly_price: 'Yearly Price',
        value_less_than_prorated: 'Value must be equal to or greater than {{prorated}} per month',
        select_children:
            'Please, select the children you would like to add for Kindergarden',
        no_children: 'You have no children above 3 years old',
        person: 'Person',
        monthly: 'Monthly',
        yearly: 'Yearly',
        main_benefit_error: 'Please check the main benefit first',
        benefit_error: 'You must select the benefit',
        price_over_error: 'You exceed the available amount',
    },
    contracts: {
        month: 'Month',
        company: 'Company',
        capital_death_case: 'Capital in case of death',
        capital_dis_case: 'Capital in case disability',
        pending_text:
            'The product is in pending review. We will update you when is contracted',
        cancel_text: 'The benefit is cancelled',
        contract_text: 'You have contracted the benefit already',
        zero_message: 'Total amount is 0',
        min_unreached: 'The minimum monthly amount has not been reached',
        max_exceeded: 'The maximum monthly amount has been exceeded',
        cancel_confirm: 'You are about to cancel the contract. Are you sure?',
        reset_message: 'The settings has been reset',
        update_confirm_message:
            'You are about to change the contract conditions, are you sure?” En that case, please check your mailbox, we will send you a confirmation email',
        select_start_month: 'select start month',
        inactive_product: 'You are not allowed to hire this product. Please contact administrator for activation.',
        saving_in_progress_error: 'You cannot modify the selection while you have an ongoing savings contract. Please complete the current process first.',
        effective_june: 'The product will be effective from June 1st',
        effective_december: 'The product will be effective from December 1st',
        saving_plan_cart_pending: 'You cannot add a new savings plan while you have one pending in your cart. Please complete or cancel the current process.',
        savings_plan_modification: 'It is only possible to modify the savings plan between April 11 and May 10 (effective: June 1) or between October 11 and November 10 (effective: December 1).'
    },
    cart: {
        data_confirm: 'Data confirmation',
        sign_contract: 'Signing contract',
        step_company: 'Company Selection',
        step_product: 'Product Selection',
        basket_selection: 'Basket Selection',
        step_months: 'Months Selection',
        step_family: 'Family Selection',
        empty_cart: 'Your cart is empty',
        agree_message:
            'By Clicking on Next Step you agree to contract automatically',
        terms: `Firma y recibirás un correo electrónico con el contrato de novación
      adjunto y la relación de productos seleccionados que deberás aceptar.
      <br />
      <br />
      Para poder finalizar tu proceso de contratación, es necesario que abras
      y aceptes las condiciones del correo. Recuerda hacerlo antes del día&nbsp;
      {{cutOffDate}} para disponer del producto el 1 del mes siguiente.`,
        pending: 'PENDING',
        completed: 'COMPLETED',
        download_doc_text: 'Please download the document, fill it out and sign it',
        edit_family: 'Edit family member',
        name: 'Name',
        surname: 'Surname',
        address: 'Address',
        zip: 'Zip',
        contact_person: 'Contact person',
        contact_phone: 'Contact phone',
        center_name: 'Center name',
        course: 'Course',
        phone_contact: 'Phone contact',
        attach_invoice: 'Please attach the invoice',
        same_kindergarten: 'Is the same kindergarten with',
        code_center: 'Code center',
        dontknow: 'If you don\'t know,',
        edit_profile: 'Edit profile',
        modality_info_details: 'Modality Information Details',
        modality: 'Modality',
        beneficiary_info: 'Beneficiary Info',
        additional_info: 'Aditional Info',
        total: 'Total',
        total_anual: 'Total Year',
        total_spent: 'TOTAL SPENT',
        flexible_bag: 'Flexible Bag',
        top_bag: 'Top Bag',
        company_bag: 'Company Bagg',
        health_provider_noselect:
            'cannot select this provider because user already hired other provider',
        no_info: 'No information required',
        expired_products: 'You have products in the cart with dates lower than company’s cut off date, please remove them to be able to hire: ',
        expired_warning: 'EXPIRED! Please, remove it',
        time_left: 'Time left',
        days: 'day(s)',
        remove_products: 'Please remove these products from the cart before contracting',
        no_permission: 'You don\'t have permission to contract this product anymore',
        payment_frequency: 'Payment frequency',
        saving_plan_modification_window_error: 'You can only modify the savings insurance between April 11th and May 10th (effective: June 1st) or between October 11th and November 10th (effective: December 1st).',
    },
    prices: {
        price: 'Price',
        discount: 'Disc.',
        total: 'Total'
    },
    countries: {
        AF: 'Afghanistan',
        AL: 'Albania',
        DE: 'Germany',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua and Barbuda',
        SA: 'Saudi Arabia',
        DZ: 'Algeria',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        AN: 'Netherlands Antilles',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BY: 'Belarus',
        BO: 'Bolivia',
        BA: 'Bosnia and Herzegovina',
        BW: 'Botswana',
        BR: 'Brazil',
        BN: 'Brunei',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        BT: 'Bhutan',
        CV: 'Cape Verde',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        QA: 'Qatar',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CY: 'Cyprus',
        CO: 'Colombia',
        KM: 'Comoros',
        CG: 'Congo',
        KP: 'North Korea',
        KR: 'South Korea',
        CI: 'Ivory Coast',
        CR: 'Costa Rica',
        HR: 'Croatia',
        CU: 'Cuba',
        CW: 'Curaçao',
        DK: 'Denmark',
        DM: 'Dominica',
        EC: 'Ecuador',
        EG: 'Egypt',
        SV: 'El Salvador',
        AE: 'United Arab Emirates',
        ER: 'Eritrea',
        SK: 'Slovakia',
        SI: 'Slovenia',
        ES: 'Spain',
        US: 'United States',
        EE: 'Estonia',
        ET: 'Ethiopia',
        PH: 'Philippines',
        FI: 'Finland',
        FJ: 'Fiji',
        FR: 'France',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgia',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GR: 'Greece',
        GL: 'Greenland',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GF: 'French Guiana',
        GG: 'Guernsey',
        GN: 'Guinea',
        GQ: 'Equatorial Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungary',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Iran',
        IQ: 'Iraq',
        IE: 'Ireland',
        BV: 'Bouvet Island',
        IM: 'Isle of Man',
        CX: 'Christmas Island',
        NF: 'Norfolk Island',
        IS: 'Iceland',
        AX: 'Åland Islands',
        KY: 'Cayman Islands',
        CC: 'Cocos Islands',
        CK: 'Cook Islands',
        FO: 'Faroe Islands',
        GS: 'South Georgia and the South Sandwich Islands',
        FK: 'Falkland Islands',
        MP: 'Northern Mariana Islands',
        MH: 'Marshall Islands',
        UM: 'United States Minor Outlying Islands',
        PN: 'Pitcairn Islands',
        SB: 'Solomon Islands',
        TC: 'Turks and Caicos Islands',
        VG: 'British Virgin Islands',
        VI: 'U.S. Virgin Islands',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        JE: 'Jersey',
        JO: 'Jordan',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KI: 'Kiribati',
        KW: 'Kuwait',
        LA: 'Laos',
        LS: 'Lesotho',
        LV: 'Latvia',
        LB: 'Lebanon',
        LR: 'Liberia',
        LY: 'Libya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao',
        MK: 'North Macedonia',
        MG: 'Madagascar',
        MY: 'Malaysia',
        MW: 'Malawi',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Morocco',
        MQ: 'Martinique',
        MU: 'Mauritius',
        MR: 'Mauritania',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NO: 'Norway',
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        OM: 'Oman',
        NL: 'Netherlands',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestine',
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PF: 'French Polynesia',
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        GB: 'United Kingdom',
        CF: 'Central African Republic',
        CZ: 'Czech Republic',
        CD: 'Democratic Republic of the Congo',
        DO: 'Dominican Republic',
        RE: 'Réunion',
        RW: 'Rwanda',
        RO: 'Romania',
        RU: 'Russia',
        EH: 'Western Sahara',
        WS: 'Samoa',
        AS: 'American Samoa',
        BL: 'Saint Barthélemy',
        BQ: 'Bonaire, Sint Eustatius and Saba',
        HM: 'Heard Island and McDonald Islands',
        KN: 'Saint Kitts and Nevis',
        SM: 'San Marino',
        MF: 'Saint Martin',
        PM: 'Saint Pierre and Miquelon',
        VC: 'Saint Vincent and the Grenadines',
        SH: 'Saint Helena, Ascension and Tristan da Cunha',
        LC: 'Saint Lucia',
        ST: 'São Tomé and Príncipe',
        SN: 'Senegal',
        RS: 'Serbia',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SX: 'Sint Maarten',
        SY: 'Syria',
        SO: 'Somalia',
        LK: 'Sri Lanka',
        SZ: 'Eswatini',
        ZA: 'South Africa',
        SD: 'Sudan',
        SS: 'South Sudan',
        SE: 'Sweden',
        CH: 'Switzerland',
        SR: 'Suriname',
        SJ: 'Svalbard and Jan Mayen',
        TH: 'Thailand',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        TJ: 'Tajikistan',
        IO: 'British Indian Ocean Territory',
        TF: 'French Southern Territories',
        TL: 'East Timor',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad and Tobago',
        TN: 'Tunisia',
        TM: 'Turkmenistan',
        TR: 'Turkey',
        TV: 'Tuvalu',
        UA: 'Ukraine',
        UG: 'Uganda',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VA: 'Vatican City',
        VE: 'Venezuela',
        VN: 'Vietnam',
        WF: 'Wallis and Futuna',
        YE: 'Yemen',
        DJ: 'Djibouti',
        ZM: 'Zambia',
        ZW: 'Zimbabwe'
    },
    common: {
        select: '-- Select --',
    }
}